import { Image, useDeviceType } from '@cian/ui-kit';
import * as React from 'react';

import { useActionButtonHandler } from './useActionButtonHandler';
import { Promo, Socket } from '../../components/ActionButton';
import { ActionButton } from '../../components/ActionButton/ActionButton';
import { TActionButtonV2 } from '../../types/actionButtonV2';
import { TActionButtonV3 } from '../../types/actionButtonV3';
import {
  extractOfferIdFromBookingCalendarUrl,
  generateBookingCalendarSettingsDeeplink,
} from '../../utils/dailyrent/generateBookingCalendarSettingsDeeplink';
import { doesButtonHaveBookingCalendarSettingsLink } from '../../utils/dailyrent/shouldShowDailyrentButtons';
import { DemandActionContainer } from '../DemandActionContainer';

type TActionButton = TActionButtonV2 | TActionButtonV3;

type TActionButtonContainerProps = {
  actionButton: TActionButton;
  messageId: string;
  communicationId?: string | null;
  index?: number;
  isOutcoming?: boolean;
};

const DEMAND_TRAP_LINK = 'homeownerLeadCreateMessage';

export const ActionButtonContainer: React.FC<TActionButtonContainerProps> = ({
  actionButton,
  messageId,
  communicationId,
  index,
  isOutcoming,
}) => {
  const { link, type, text } = actionButton;
  const deviceType = useDeviceType();
  const isDesktop = deviceType === 'desktop';

  const аctionButtonHandler = useActionButtonHandler(actionButton, messageId, communicationId);

  // Переопределяем ссылку в зависимости от внешних условий
  const getActualLink = (): string | undefined => {
    if (!link) {
      return undefined;
    }

    const isBookingCalendarSettingsButton = doesButtonHaveBookingCalendarSettingsLink(actionButton);
    if (isBookingCalendarSettingsButton && !isDesktop) {
      const offerId = extractOfferIdFromBookingCalendarUrl(link);
      if (offerId) {
        return generateBookingCalendarSettingsDeeplink(offerId);
      }
    }

    return link;
  };

  const actualLink = getActualLink();

  //блок для кнопок типа TActionButtonV3
  if ('style' in actionButton) {
    if (actionButton.style === 'buttonPrimary' || actionButton.style === 'buttonSecondary') {
      return (
        <ActionButton
          key={`chatbot-action-button-${index}`}
          theme={
            isOutcoming
              ? 'fill_white_primary'
              : actionButton.style === 'buttonPrimary'
                ? 'fill_primary'
                : 'fill_secondary'
          }
          beforeIcon={
            actionButton.icon && actionButton.iconPosition === 'start' ? (
              <Image
                src={actionButton.icon}
                width={16}
                height={16}
                preloader={false}
                borderRadius="0"
                data-name="actionButton_image_start"
              />
            ) : undefined
          }
          afterIcon={
            actionButton.icon && actionButton.iconPosition === 'end' ? (
              <Image
                src={actionButton.icon}
                width={16}
                height={16}
                preloader={false}
                borderRadius="0"
                data-name="actionButton_image_end"
              />
            ) : undefined
          }
          actionButtonHandle={аctionButtonHandler}
        >
          {text}
        </ActionButton>
      );
    }

    if (actionButton.style === 'link') {
      return (
        <Promo
          link={actualLink as string}
          text={text}
          onClick={аctionButtonHandler}
          icon={actionButton.icon}
          iconPosition={actionButton.iconPosition}
          gravity={actionButton.gravity}
          isOutcoming={isOutcoming}
          index={index}
        />
      );
    }
  }

  if (actualLink === DEMAND_TRAP_LINK) {
    return <DemandActionContainer actionButton={actionButton} />;
  }

  if (type === 'socket') {
    return <Socket text={text} onClick={аctionButtonHandler} />;
  }

  if (actualLink) {
    return <Promo link={actualLink as string} text={text} onClick={аctionButtonHandler} />;
  }

  return null;
};
